const BoshLosCallback = () => null;

export default BoshLosCallback;
